import React, {useEffect, useState} from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import * as S from './style';
import QuestionResult from './questions-outcome';
import { useDispatch, useSelector } from 'react-redux'
import { setBackButtonLoading, setBackButtonNotLoading } from '../../../stores/splashverse-onboarding/actions';

const BuildFocusArea = ({isNextStep, goToNextHandler, currentStep}) => {
  const [animate, setAnimate] = useState(false);
  const [settingUpLearningPlan, settingUpLearningPlanHandler] = useState(false);
  const [headingHideTransition, setHeadingHideTransition] = useState(false);
  const [headShowTransition, setHeadShowTransition] = useState(false);
  const [headingText, setHeadingText] = useState('');
  const [selectedSubject, setSelectedSubject] = useState(null);

  const { childScreenName, selectedGrade, isPersolizationSkipped, gradeCodeMap } = useSelector(state => {
    return {
      childScreenName: state.childScreenName,
      selectedGrade: state.selectedGrade,
      isPersolizationSkipped: state.skipPersonalizedToggle,
      gradeCodeMap: state.gradeCodeMap,
    }
  });

  const dispatch = useDispatch();

  useEffect(() => {
    setSelectedSubject(currentStep.slice(20));
  }, [])

  useEffect(() => {
    let shouldSkipAnimationText = isPersolizationSkipped || !isNextStep
    let Animationtiming = shouldSkipAnimationText ? 2000 : 10000;
    setHeadingText(`Here are the skills to help ${childScreenName} master ${gradeCodeMap.get(selectedGrade).title}`);
    setHeadShowTransition(shouldSkipAnimationText);
    !shouldSkipAnimationText && eventHandler('Question Animation Screen Viewed');
    settingUpLearningPlanHandler(true);
    setTimeout(() => { 
      !shouldSkipAnimationText && eventHandler('Question Animation Completed');
      settingUpLearningPlanHandler(false)
    }, Animationtiming);
    setTimeout(() =>
      setHeadShowTransition(true), Animationtiming);
    setAnimate(true);
  }, [selectedSubject])

  useEffect(() => {
    if (settingUpLearningPlan) {
      dispatch(setBackButtonLoading());
    } else {
      dispatch(setBackButtonNotLoading());
    }
  },[settingUpLearningPlan]);

  const eventHandler = (name) => {
    trackAnalyticsEvent(name, {
      Platform: 'web', 
      Grade: selectedGrade,
      Subject: selectedSubject
    })
  }

  const doHeaderTransition = (exit) => {
    setHeadShowTransition(false);
    setTimeout(() => {
      setHeadShowTransition(true);
    }, 700);
  }

  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
          {selectedSubject &&
            (!isPersolizationSkipped && settingUpLearningPlan) ? 
            <>
              <S.SetUpText>Setting up {childScreenName}’s Learning Path...</S.SetUpText>
              <S.SetUpText timeOut={'6s'}>Identifying skills {childScreenName} needs to learn, practice and master...</S.SetUpText>
            </> : 
            <>
              <SS.StepHeader 
                startHideTransition={headingHideTransition} 
                showTransition={headShowTransition}
              >
                {headingText}
              </SS.StepHeader>
              <QuestionResult 
                setHeadingTransition={setHeadingHideTransition}
                goToNextHandler={goToNextHandler}
                setHeadingText={setHeadingText}
                doHeaderTransition={doHeaderTransition}
                isNextStep={isNextStep}
                selectedSubject={selectedSubject}
              />
            </>
          }
        </SS.OnboardingStepWrapper>
      )}
    </Transition>
  )
}

export default BuildFocusArea;